import { useCallback, useEffect, useRef } from 'react';

export const usePlayVideoManuallyOnError = (
  introVideoRef: React.RefObject<HTMLVideoElement>
) => {
  const globalEventListenerAttached = useRef(false);
  const onBodyClick = useCallback(() => {
    introVideoRef.current?.play();
  }, [introVideoRef]);
  useEffect(() => {
    return () => {
      document.removeEventListener('click', onBodyClick);
    };
  }, [onBodyClick]);

  return {
    onVideoError: () => {
      if (!globalEventListenerAttached.current) {
        document.addEventListener('click', onBodyClick);
        globalEventListenerAttached.current = true;
      }
    },
  };
};
